import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import ReactDOM from 'react-dom';

const canonicalURL = ({
  origin,
  pathname
}) => `${origin}${pathname}`.replace(/\/$/, '');

export const Meta = (_ref) => {
  let {
    head = document.head
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["head"]);

  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx("meta", Object.assign({}, props)), head);
};
export const MetaOpenGraph = ({
  head = document.head,
  property,
  content
}) => {
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx("meta", {
    property: `og:${property}`,
    content: content
  }), head);
};
export const MetaTwitter = ({
  head = document.head,
  property,
  content
}) => {
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx("meta", {
    name: `twitter:${property}`,
    content: content
  }), head);
};
export const PrerenderReady = () => {
  useEffect(() => {
    window.prerenderReady = true;
  }, []);
  return null;
};
export const PrerenderStatusCode = ({
  head = document.head,
  status
}) => {
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx("meta", {
    content: status,
    name: "prerender-status-code"
  }), head);
};
export const CanonicalLink = ({
  head = document.head,
  href = ''
}) => {
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/_jsx("link", {
    rel: "canonical",
    href: href
  }), head);
};

const PrerenderTags = ({
  head = document.head,
  title,
  description,
  image,
  type = 'website'
}) => {
  useEffect(() => {
    const titles = head.querySelectorAll('title');

    for (let i = 0; i < titles.length; i++) {
      titles[i].innerHTML = title;
    }
  }, [head, title]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "title",
      content: title
    }), /*#__PURE__*/_jsx(Meta, {
      name: "description",
      content: description
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "description",
      content: description
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "url",
      content: canonicalURL(window.location)
    }), /*#__PURE__*/_jsx(CanonicalLink, {
      href: canonicalURL(window.location)
    }), image && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(MetaOpenGraph, {
        property: "image",
        content: image.replace(/^\/\//, `${window.location.protocol}//`)
      }), /*#__PURE__*/_jsx(MetaOpenGraph, {
        property: "image:width",
        content: "1200"
      }), /*#__PURE__*/_jsx(MetaOpenGraph, {
        property: "image:height",
        content: "630"
      }), /*#__PURE__*/_jsx(MetaTwitter, {
        property: "image",
        content: image.replace(/^\/\//, `${window.location.protocol}//`)
      })]
    }), /*#__PURE__*/_jsx(MetaOpenGraph, {
      property: "type",
      content: type
    }), /*#__PURE__*/_jsx(MetaTwitter, {
      property: "card",
      content: "summary_large_image"
    })]
  });
};

export default PrerenderTags;